/**
 * The two surfaces a gateway key may call, as the Settings UI names them.
 * `inference` is the LLM proxy; `api` is the data API at api.trainloop.ai.
 * Shared by the create dialog (which scopes to ask for) and the keys list
 * (how to label what a key carries), so the two never drift.
 */

import { ApiKeyCreateRequestScopesItem } from '@/api/generated/model'

export type ApiKeyScope = ApiKeyCreateRequestScopesItem

const SCOPE_LABELS: Record<ApiKeyScope, string> = {
  inference: 'Inference',
  api: 'Data API',
}

/** Inference is always on. The data API is opt-in (TRA-1217). */
export function requestedScopes(allowDataApi: boolean): ApiKeyScope[] {
  return allowDataApi ? ['inference', 'api'] : ['inference']
}

/**
 * A scope as the keys list shows it. The gateway carries scopes as free
 * strings, so one it minted outside this UI is shown verbatim rather than
 * hidden.
 */
export function scopeLabel(scope: string): string {
  return isKnownScope(scope) ? SCOPE_LABELS[scope] : scope
}

function isKnownScope(scope: string): scope is ApiKeyScope {
  return scope in SCOPE_LABELS
}
